import { Box } from "@mui/material";
import { closeSnackbar } from "notistack";

export const snackbarAction = (snackbarId: string | number) => {
    return <Box component={"div"} sx={{ cursor: "pointer" }}
        position={"absolute"} top={0} bottom={0} left={0} right={0}
        onClick={() => closeSnackbar(snackbarId)} />
}
